import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
import { AngularFireFunctions } from 'angularfire2/functions';

declare var Email: any;

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  constructor(private functions: AngularFireFunctions) { }

  // sendEmail(subject: any, body: any, toAddress?: any) {
  //   // debugger;
  //   let emailList = toAddress || "firozss31@gmail.com,";
  //   // let emailList =  "sunilsk.ssk16@gmail.com,";
  //   // let toAddress = "firozss31@gmail.com";

  //   return Email.send({
  //     Host: "smtp.gmail.com",
  //     Username: "info.corpcrs@gmail.com",
  //     Password: "Corp@123",
  //     To: emailList,
  //     From: "info.corpcrs@gmail.com",
  //     Subject: subject,
  //     Body: body,
  //   })
  // }

  // this function will send email from one email id to another email id
  sendEmail(subject: any, body: any, toAddress?: any) { // New send mail function
    return new Promise((resolve, reject) => {
      const sendMailUsingNodemailer = this.functions.httpsCallable('sendMailUsingNodemailer');

      const data = {
        clientEmailId: toAddress,
        subject: subject,
        body: body
      }
      console.log(data)
      const obs = sendMailUsingNodemailer(data);

      obs.subscribe((response) => {
        console.log(response);
        if (response.success === true) {
          resolve(response);
        } else {
          reject({ errMsg: 'firebase function error' });
        }
      });
    });
    
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}
